<!--康晋定制十千伏看板-->
<template>
	<div>
		<p class="overViewTitle">高压监测</p>
		<div class="flexStart" style="background: #FCFCFC;height: calc(100% - 31px);">
			<div class="flexCenterColumn" style="padding: 0 20px;height: 100%;">
				<div class="colorBox" style="background: #008000;">

				</div>
				<p>正常</p>
				<div class="colorBox" style="background: red;">

				</div>
				<p>异常</p>
				<div class="colorBox" style="background: gray;">

				</div>
				<p>不具备</p>
			</div>
			<div>
				<div style="width: 120px;margin-top: 10px;">
					<span>设备名称</span>
				</div>
				<div v-for="it in itemList" style="width: 120px;margin-top: 10px;">
					<span>{{it.name}}</span>
				</div>
			</div>
			<div class="custom-scrollbar flexStart" style="width: 600px;">
				<div v-for="item in loadDeviceList" class="flexCenterColumn boxDiv">
					<p style="text-align: center;white-space: nowrap;text-overflow: ellipsis;width: 100px;overflow: hidden;" :title="item.name">{{item.name}}</p>
					<template v-for="it in itemList">
						<div class="colorBox" :style="getColor(item,it.apptypeNo)"></div>
					</template>
				</div>
				<p style="width: 100px;" v-for="item in (6-loadDeviceList.length>0?6-loadDeviceList.length:0)"></p>
			</div>
			<div class="flexCenterColumn">
				<p>无故障运行时间</p>
				<p class="timeBox">最长 : {{maxRunTime}} 天</p>
			</div>
			<canvasCircle color="#35abe3" style="height: 150px;width: 150px;" pcontent="设备健康度" :rate="healthValue"></canvasCircle>
		</div>
	</div>
</template>

<script>
	import canvasCircle from '@/page/unitProfile/canvasCircle.vue'
	export default {
		components: {
			canvasCircle
		},
		props: {},
		data() {
			return {
				itemList: [{
					name: '气体信号',
					apptypeNo: 291
				}, {
					name: '超温',
					apptypeNo: 292
				}, {
					name: '卡关储能',
					apptypeNo: 293
				}, {
					name: '线路保护动作',
					apptypeNo: 294
				}, {
					name: '远方/就地操作信号',
					apptypeNo: 295
				}, {
					name: '开关位置信号',
					apptypeNo: 296
				}, {
					name: '终端装置故障信号',
					apptypeNo: 297
				}],
				//设备对应的用到的变量的映射
				deviceNoMap: {},
				deviceNoToMaxRunTime: {}
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.realTimeValueStore.commit("addKeys", this.allVariableList)
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.allVariableList)
		},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getColor() {
				return (item, apptypeNo) => {
					var sty = {
						background: 'gray'
					}
					//拿到指定变量
					var variable = this.deviceNoMap['no' + item.no]['type' + apptypeNo]
					if (isempty(variable)) {
						return sty
					}
					//取实时值
					var value = this.realTimeValueStore.getters.getValue([variable.fromName])[0]
					if (value != undefined) {
						switch (parseInt(value)) {
							case 0:
								sty.background = 'red'
								break
							case 1:
								sty.background = '#008000'
								break
						}
					}
					return sty
				}
			},
			loadDeviceList() {
				//当前单位下的高压设备列表
				var baseTree = this.$store.archivesStore.getters.getArchivesTreeByUnitId()
				if (isempty(baseTree)) {
					return []
				}
				var list = baseTree.next.filter(item => {
					return item.entityName == 'AppEquipmentArchives' && item.typeCode == "HighVoltageInletCabinet"
				})
				return list.map(item => {
					item.installTime = new Date().getTime() - 365*24*60*60*1000
					return item
				})
			},
			healthValue() {
				//健康度，每个设备从安装起，每年减少5%，所有高压设备的健康度平均值作为整个单位的健康度，安装时间在台账中配置
				var count = 0
				var num = 0
				var nowYear = new Date().getFullYear()
				for (var i = 0, len = this.loadDeviceList.length; i < len; i++) {
					var device = this.loadDeviceList[i]
					//获取台账信息
					var infoList = this.$store.archivesStore.getters.getArchivesInfoById(device.id)
					//找安装时间
					var item = infoList.find(item => item.propertyCode == 'InstallTime')
					if (isempty(item) || isempty(item.value)) {
						//没有配置就是无效，忽略
					} else {
						var time = new Date(item.value)
						this.$set(this.loadDeviceList[i], 'installTime', time.getTime())
						var h = (nowYear - time.getFullYear()) * 5
						count += (100 - h > 0 ? 100 - h : 0)
						num++
					}
				}
				if (count == 0) {
					return 0
				}
				return cutDigital(count / num)
			},
			maxRunTime() {
				var vDeviceMap = this.$store.archivesStore.getters.getBindInfoMapByArchivesIdList(this.loadDeviceList.map(it => it
					.id))
				var count = 0
				var sum = 0
				for (var i = 0, len = this.loadDeviceList.length; i < len; i++) {
					var item = this.loadDeviceList[i]
					var device = vDeviceMap[item.id]
					if (device != undefined) {
						var time = this.deviceNoToMaxRunTime[device.id]
						if (time == undefined) {
							let id = device.id
							this.$api.eventApi.getFailureFreeTimeByDeviceNo(device.id, item.installTime, Date.now(), undefined, respon => {
								this.$set(this.deviceNoToMaxRunTime, id, respon)
							})
						} else {
							count += parseInt(time)
							sum++
						}
					}
				}
				if (count == 0) {
					return 0
				}
				return Math.floor(count / (24 * 60 * 60 * 1000 * sum))
			},
			minRunTime() {
				return item => {
					return 0
				}
			},
			allVariableList() {
				var itemNoList = this.itemList.map(item => item.apptypeNo)
				//所有设备的所有需要获取实时值的变量列表
				var list = []
				for (var i = 0, len = this.loadDeviceList.length; i < len; i++) {
					var deviceMap = {}
					var item = this.loadDeviceList[i]
					var tree = this.$store.variableStore.getters.getVariableTree(item.no)
					//找出我们要的变量
					for (var i1 = 0, len1 = tree.length; i1 < len1; i1++) {
						var t = tree[i1].next
						list.addAll(t.filter(it => {
							var isRight = itemNoList.includes(it.typeNo)
							if (isRight) {
								deviceMap['type' + it.typeNo] = it
							}
							return isRight
						}))
					}
					this.$set(this.deviceNoMap, 'no' + item.no, deviceMap)
				}
				return list.map(item => item.fromName)
			}
		},
		watch: {
			allVariableList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
			},
		},
		methods: {}
	}
</script>

<style scoped>
	.overViewTitle {
		font-size: 14px;
		padding: 0 10px;
		border-bottom: 1px solid #ccc;
		height: 30px;
		line-height: 30px;
	}

	.boxDiv {
		position: relative;
	}

	.colorBox {
		width: 40px;
		height: 20px;
		margin-top: 10px;
	}

	.timeBox {
		padding: 15px;
		margin: 10px;
		background: #00C6FF;
		color: white;
	}
</style>
